import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { MagicLinkVerifyPage } from './pages/MagicLinkVerifyPage';
import { TreeListPage } from './pages/TreeListPage';
import { TreePage } from './pages/TreePage';
import { InviteAcceptPage } from './pages/InviteAcceptPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/verify" element={<MagicLinkVerifyPage />} />
        <Route
          path="/invite"
          element={
            <ProtectedRoute>
              <InviteAcceptPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trees"
          element={
            <ProtectedRoute>
              <TreeListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trees/:treeId"
          element={
            <ProtectedRoute>
              <TreePage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/trees" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
